
import axios from 'axios';

export const HTTP = axios.create({
    timeout: 10000,
    //baseURL: window.halbtax_apiUrl,
    // eslint-disable-next-line no-undef
    baseURL: config.APP_URL,
    withCredentials: true,
    credentials: true,
    emulateJSON : true,
  })
